import { ReactComponent as IconMenu01 } from "../../../styles/assets/svg/icon-home.svg";
import { ReactComponent as IconMenu02 } from "../../../styles/assets/svg/icon-drive.svg";
import { ReactComponent as IconMenu03 } from "../../../styles/assets/svg/icon-user.svg";
import { ReactComponent as IconMenu04 } from "../../../styles/assets/svg/icon-moreGear-black.svg";
import * as S from "./bottomNavItem.styles";
import { useNavigate } from "react-router";

interface NavItemProps {
  icon: number;
  url: string;
  menuTitle: string;
}

export const navIcon = [
  {
    id: 1,
    icon: <IconMenu01 />,
  },
  {
    id: 2,
    icon: <IconMenu02 />,
  },
  {
    id: 3,
    icon: <IconMenu03 />,
  },
  {
    id: 4,
    icon: <IconMenu04 />,
  },
  {
    id: 5,
    icon: <IconMenu04 />,
  },
  {
    id: 6,
    icon: <IconMenu04 />,
  },
];

export const BottomNavItem = ({ icon, url, menuTitle }: NavItemProps) => {
  const location = window.location.href;

  const navigate = useNavigate();
  return (
    <a
      onClick={() => {
        // 하단 탭바에서 내운송정보 클릭했을때만 페이지 이동을 다르게 처리
        if (url === "/myDrive") {
          navigate(url);
          return;
        }
        navigate(url);
        // window.location.href = url;
      }}
    >
      {/* <S.BottomNavItem active={location.includes(url) ? true : false}> */}
      <S.BottomNavItem active={location.includes(url) ? true : false}>
        <S.NavItemIcon>{navIcon[icon].icon}</S.NavItemIcon>
        <S.NavItemTit>{menuTitle}</S.NavItemTit>
      </S.BottomNavItem>
    </a>
  );
};
